import styled from '@emotion/styled'

import {Divider} from '@vio/atlas/Divider'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'

import {AP_DESKTOP_LARGE_COLUMN_WIDTH, OFFER_BOX_WIDTH} from './constant'

export const Wrapper = styled.div`
  padding: ${cssTheme.layout.spacing.s500} 0 0;
  min-height: 100vh;
`
export const GridGalleryWrapper = styled.section<{
  noBottomMargin?: boolean
}>`
  margin-bottom: ${({noBottomMargin}) =>
    noBottomMargin
      ? cssTheme.layout.spacing.s000
      : cssTheme.layout.spacing.s700};
`
export const MainContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${cssTheme.layout.spacing.s700};
`
export const LeftContentWrapper = styled.div`
  flex: 1;
  max-width: ${AP_DESKTOP_LARGE_COLUMN_WIDTH}px;
  overflow: hidden;
`

export const HotelDetailsWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s300};
`
export const ReviewSummaryWrapper = styled.div`
  margin-top: ${cssTheme.layout.spacing.s500};
`
export const RightContentWrapper = styled.div`
  width: ${OFFER_BOX_WIDTH}px;
  position: sticky;
  display: flex;
  flex-direction: column;
  scroll-margin-top: var(--scroll-top-margin, 0px);
  top: var(--scroll-top-margin, 0px);
  z-index: 1;
`

export const DividerContainer700 = styled(Divider)`
  margin: ${cssTheme.layout.spacing.s700} 0;
`

export const DividerContainer = styled(Divider)`
  margin: ${cssTheme.layout.spacing.s900} 0;
`

export const FooterWrapper = styled.footer`
  margin: 0 ${minus(cssTheme.layout.spacing.s400)}
    ${minus(cssTheme.layout.spacing.s500)};
`

export const RoomsSectionWrapper = styled.div`
  padding: ${cssTheme.layout.spacing.s900} 0;
  background-color: ${cssTheme.colors.background.neutral.secondary};
`

export const PriceWatchWrapper = styled.div`
  margin: 0 0 ${cssTheme.layout.spacing.s500};
  &.--before-points-toggle {
    margin-bottom: ${cssTheme.layout.spacing.s300};
  }
  &:empty {
    margin: 0;
  }
`
